import {Chart} from 'chart.js'
import {getFontFamilyName} from '@/utils/css-styles-utils'
import {colors} from '@/constants/theme/colors'

Chart.defaults.backgroundColor = colors.primary800
Chart.defaults.plugins.title = {
    ...Chart.defaults.plugins.title,
    color: colors.dark,
    font: {
        size: 14,
        weight: '500',
        family: getFontFamilyName(),
        lineHeight: 3
    }
}
